import cn from 'classnames';

import styles from './Arrow.module.css';
import { Icon } from './Icon';

export function Arrow({
  className,
  isUp = false,
}: {
  className?: string;
  isUp?: boolean;
}): JSX.Element {
  return (
    <Icon
      icon="dropdown"
      className={cn(styles.icon, { [styles.up]: isUp }, className)}
    />
  );
}
